import { BlocksIconMessageMultiple } from 'blocks-nextjs/blocks-web-components/components/icon/icons/message-multiple';
import React from 'react';
import { createComponent } from '../../CustomWrapper/CustomWrapper';

export const CatIconMessageMultiple = createComponent({
  react: React,
  tagName: 'cat-icon-message-multiple',
  elementClass: BlocksIconMessageMultiple
});
